import React from 'react';
import './ChildrenSelector.css';

const ChildrenSelector = ({ children, selectedChild, onChildChange }) => {
  if (!children || children.length <= 1) return null;
  
  return (
    <div className="children-selector">
      <label htmlFor="child-select">選擇子女：</label>
      <select 
        id="child-select"
        value={selectedChild?.id || selectedChild?.student_id || ''} 
        onChange={(e) => {
          const child = children.find(c => 
            (c.id === e.target.value) || (c.student_id === e.target.value)
          );
          if (child && onChildChange) {
            onChildChange(child);
          }
        }}
        className="child-select"
      >
        <option value="">全部子女</option>
        {children.map(child => (
          <option 
            key={child.id || child.student_id} 
            value={child.id || child.student_id}
          >
            {child.name || child.student_name || '未命名'} 
            {child.class_id ? ` (${child.class_id})` : ''}
            {child.class_name ? ` - ${child.class_name}` : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ChildrenSelector;

